import { createPortal } from "react-dom"
import { Toast } from "."
import { string, oneOf, shape, arrayOf } from "prop-types"

const ToastList = ({ toasts }) => {
  return createPortal(
    <div className="toast--list">
      {toasts.map(({ id, message, type }) => (
        <Toast key={id} id={id} message={message} type={type} />
      ))}
    </div>,
    document.body
  )
}

ToastList.propTypes = {
  toasts: arrayOf(
    shape({
      id: string,
      message: string,
      type: oneOf(["success", "info"])
    })
  )
}

export default ToastList
